import * as Yup from 'yup';
import {
  CasReactHookFormDialog,
  CasRHFMultilineTextField,
  CasRHFSelect,
} from 'src/compass/shared/components';
import { StringsToOptions } from 'src/compass/shared/util/StringsToOptions';
import { IGeneralObjectType } from 'src/compass/site/util';
import { getSelectSchema, getStringSchema } from 'src/compass/shared/schemas';
import useUpdateMutation from 'src/compass/shared/hooks/reactQuery/useUpdateMutation';
import useAddMutation from 'src/compass/shared/hooks/reactQuery/useAddMutation';
import { onSuccessEnqueueSnackbar } from 'src/compass/shared/util/onSuccessEnqueueSnackbar';

import { RHFLrpProcessorSelect } from './LrpProcessorSelect';

const ClaimCallbackSchema = Yup.object().shape({
  type: getSelectSchema('Type'),
  assignedToEmployeeId: getSelectSchema('Assigned To'),
  callbackNotes: getStringSchema(1000, 'Notes').notRequired(),
});

const TYPE_OPTIONS = StringsToOptions(['Deficient', 'Rejected', 'Other']);

type ClaimCallbackDialogProps = {
  url: string;
  title: string;
  submitButtonLabel?: string;
  defaultValues?: IGeneralObjectType;
  mutationType?: 'add' | 'update';
  onClose: VoidFunction;
  endorsementId: number;
  onUpdated: Function;
};

export default function ClaimCallbackDialog({
  defaultValues = {},
  title,
  submitButtonLabel = 'Save',
  mutationType = 'add',
  url,
  endorsementId,
  onClose,
  onUpdated,
}: ClaimCallbackDialogProps) {
  function onSuccess(response: any) {
    onSuccessEnqueueSnackbar(response);
    onUpdated();
    onClose();
  }

  const addMutation = useAddMutation({ url, onSuccess });
  const updateMutation = useUpdateMutation({ url, onSuccess });

  const onSubmit = (payload: any) => {
    if (mutationType === 'add') addMutation.mutate({ endorsementId, ...payload });
    else updateMutation.mutate({ endorsementId, ...payload });
  };

  return (
    <CasReactHookFormDialog
      open
      title={title}
      submitButtonLabel={submitButtonLabel}
      defaultValues={defaultValues}
      onClose={onClose}
      onSubmit={onSubmit}
      schema={ClaimCallbackSchema}
    >
      <CasRHFSelect name="type" label="Type" options={TYPE_OPTIONS} disabled />
      <RHFLrpProcessorSelect name="assignedToEmployeeId" label="Assigned To" />
      <CasRHFMultilineTextField name="callbackNotes" label="Notes" />
    </CasReactHookFormDialog>
  );
}
